import { render } from "./Gastrology.vue?vue&type=template&id=600cda74&scoped=true"
import script from "./Gastrology.vue?vue&type=script&lang=ts"
export * from "./Gastrology.vue?vue&type=script&lang=ts"

import "./Gastrology.vue?vue&type=style&index=0&id=600cda74&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-600cda74"

export default script